// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3dUC9","col":"styles_col__23yAA","fulfillmentStatus":"styles_fulfillmentStatus__1y_6f","emailCol":"styles_emailCol__2TlI8"};